import { render, staticRenderFns } from "./StaffRates.vue?vue&type=template&id=270b4406&scoped=true"
import script from "./StaffRates.vue?vue&type=script&lang=js"
export * from "./StaffRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b4406",
  null
  
)

export default component.exports